import { K8sDistributionType } from '@/react/portainer/environments/types';
import { useCurrentEnvironment } from '@/react/hooks/useCurrentEnvironment';
import { PageHeader } from '@/react/components/PageHeader';
import { OmniUpdateWidget } from '@/react/kubernetes/cluster/HomeView/omni/OmniUpdateWidget';
import { NodesDatatable } from '@/react/kubernetes/cluster/HomeView/NodesDatatable';
import { OmniNodesDatatable } from '@/react/kubernetes/cluster/HomeView/OmniNodesDatatable/OmniNodesDatatable';

import { ClusterResourceReservation } from './ClusterResourceReservation';
import { GpuSummaryWidget } from './GpuWidget/GpuSummaryWidget';

export function ClusterView() {
  const { data: environment } = useCurrentEnvironment();

  return (
    <>
      <PageHeader
        title="Cluster"
        breadcrumbs={[
          { label: 'Environments', link: 'portainer.endpoints' },
          {
            label: environment?.Name || '',
            link: 'portainer.endpoints.endpoint',
            linkParams: { id: environment?.Id },
          },
          'Cluster information',
        ]}
        reload
      />

      <ClusterResourceReservation />

      <GpuSummaryWidget />

      {environment?.CloudProvider?.Provider === K8sDistributionType.OMNI && (
        <OmniUpdateWidget />
      )}

      <div className="row">
        {environment?.CloudProvider?.Provider === K8sDistributionType.OMNI ? (
          <OmniNodesDatatable />
        ) : (
          <NodesDatatable />
        )}
      </div>
    </>
  );
}
